import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Alert,
  Divider,
  IconButton,
  InputAdornment,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { login } from "../../services/auth";
import { Map as MapIcon, PersonAdd as PersonAddIcon } from '@mui/icons-material';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await login(email, password);
      onLogin();
    } catch (err) {
      setError('Credenciais inválidas');
    }
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          display: 'flex',
          width: '100%',
          maxWidth: isMobile ? '100%' : 900,
          height: isMobile ? '100vh' : '600px',
          flexDirection: isMobile ? 'column' : 'row',
          borderRadius: isMobile ? 0 : 4,
          overflow: 'hidden',
        }}

      >
        {/* Seção Esquerda - Cedro Produtivo */}
        <Box
          sx={{
            flex: 1,
            bgcolor: '#10641c',
            color: 'white',
            p: isMobile ? 3 : 5,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* Círculos decorativos */}
          {!isMobile && (
            <>
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -50,
                  left: -50,
                  width: 150,
                  height: 150,
                  bgcolor: '#fff414',
                  borderRadius: '50%',
                  opacity: 0.5,
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 50,
                  left: 50,
                  width: 100,
                  height: 100,
                  bgcolor: '#fff414',
                  borderRadius: '50%',
                  opacity: 0.5,
                }}
              />
            </>
          )}
          <Typography variant={isMobile ? 'h6' : 'h4'} align="center" sx={{ fontWeight: 'bold', mb: 1 }}>
            Conecta Mais
          </Typography>
          <Typography variant="body2" align="center" sx={{ fontStyle: 'italic', color: '#d4edda', fontSize: isMobile ? '0.9rem' : '1rem' }}>
            Impulsione seu futuro: o empreendedorismo começa aqui!
          </Typography>
        </Box>

        {/* Seção Direita - Formulário */}
        <Box
          sx={{
            flex: 1,
            p: isMobile ? 3 : 5,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            bgcolor: 'white',
          }}
        >
          <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
            Entrar
          </Typography>
          <Box component="form" onSubmit={handleLogin} sx={{ mt: 1 }}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#10641c',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#10641c',
                },
              }}
            />
            <TextField
              fullWidth
              label="Senha"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClickShowPassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#10641c',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#10641c',
                },
              }}
            />
            {/* <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mb: 2 }}>
              <Button onClick={() => navigate('/verify-email')} variant="body2" sx={{ color: '#10641c', textDecoration: 'none', '&:hover': { color: '#0e5517' }, textTransform: 'none' }}>
                Esqueceu a senha?
              </Button>
            </Box> */}
            {error && (
              <Typography color="error" variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
                {error}
              </Typography>
            )}
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ py: 1.5, mb: 2, bgcolor: '#10641c', '&:hover': { bgcolor: '#0e5517' }, marginTop: "20px" }}
            >
              Entrar
            </Button>
            {message && (
              <Alert
                severity={message.includes('sucesso') ? 'success' : 'error'}
                sx={{ mt: 2 }}
              >
                {message}
              </Alert>
            )}
            <Divider sx={{ my: 1 }}>ou</Divider>
            {/* <Button
              fullWidth
              variant="outlined"
              sx={{ py: 1.5, borderColor: '#10641c', color: '#10641c', mb: 1, '&:hover': { backgroundColor: 'rgba(16, 100, 28, 0.08)' } }}
              onClick={() => navigate('/signUp')}
              startIcon={<PersonAddIcon />}
            >
              Cadastra-se como empreendedor
            </Button> */}

            <Button
              fullWidth
              variant="outlined"
              component={Link}
              to="/dashboard"
              sx={{
                py: 1.5,
                borderColor: '#10641c',
                color: '#10641c',
                '&:hover': {
                  borderColor: '#0e5517',
                  bgcolor: 'rgba(16, 100, 28, 0.08)',
                },
                mt: 1,
              }}
              startIcon={<MapIcon />}
            >
              Acessar Mapa
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;